import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './Routes';

const router = createBrowserRouter(routes, { basename: process.env.PUBLIC_URL });

const RouteProvider = () => <RouterProvider router={router} />;

export default RouteProvider;
